import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Development from "../views/Development.vue";
import Login from "../views/Login.vue";
import routerMaintenance from "./maintenance";
import routerRoyalties from "./royalties";
import routerInvoices from "./invoices";
import routerReports from "./reports";
import routerPhotos from "./photos";
import routerProviders from "./providers";
import routerExpress from "./express";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/dashboard",
    name: "Home",
    component: Home,
  },
  {
    path: "/escolher-empresa",
    name: "ChooseCompany",
    component: () =>
      import(
        /* webpackChunkName: "ChooseCompany" */ "@/views/ChooseCompany.vue"
      ),
  },
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/tipo-fornecedor",
    exact: true,
    name: "ProviderType",
    component: () =>
      import(
        /* webpackChunkName: "providerTypeList" */ "@/views/ProviderType/List.vue"
      ),
  },
  {
    path: "/tipo-fornecedor/novo",
    name: "ProviderTypeAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "providerTypeAdd" */ "@/views/ProviderType/Form.vue"
      ),
  },
  {
    path: "/tipo-fornecedor/:id",
    name: "ProviderTypeEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "providerTypeEdit" */ "@/views/ProviderType/Form.vue"
      ),
  },
  {
    path: "/categoria",
    exact: true,
    name: "Category",
    component: () =>
      import(
        /* webpackChunkName: "CategoryList" */ "@/views/Category/List.vue"
      ),
  },
  {
    path: "/categoria/novo",
    name: "CategoryAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "CategoryAdd" */ "@/views/Category/Form.vue"),
  },
  {
    path: "/categoria/:id",
    name: "CategoryEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "CategoryEdit" */ "@/views/Category/Form.vue"
      ),
  },
  {
    path: "/subcategoria",
    exact: true,
    name: "Subcategory",
    component: () =>
      import(
        /* webpackChunkName: "SubcategoryList" */ "@/views/Subcategory/List.vue"
      ),
  },
  {
    path: "/subcategoria/novo",
    name: "SubcategoryAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "SubcategoryForm" */ "@/views/Subcategory/Form.vue"
      ),
  },
  {
    path: "/subcategoria/:id",
    name: "SubcategoryEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "SubcategoryForm" */ "@/views/Subcategory/Form.vue"
      ),
  },
  {
    path: "/colecao",
    exact: true,
    name: "Collection",
    component: () =>
      import(
        /* webpackChunkName: "CollectionList" */ "@/views/Collection/List.vue"
      ),
  },
  {
    path: "/colecao/novo",
    name: "CollectionAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "CollectionAdd" */ "@/views/Collection/Form.vue"
      ),
  },
  {
    path: "/colecao/:id",
    name: "CollectionEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "CollectionEdit" */ "@/views/Collection/Form.vue"
      ),
  },
  {
    path: "/empresa",
    exact: true,
    name: "Company",
    component: () =>
      import(/* webpackChunkName: "CompanyList" */ "@/views/Company/List.vue"),
  },
  {
    path: "/empresa/novo",
    name: "CompanyAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "CompanyAdd" */ "@/views/Company/Form.vue"),
  },
  {
    path: "/empresa/:id",
    name: "CompanyEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "CompanyEdit" */ "@/views/Company/Form.vue"),
  },
  {
    path: "/empresa/view/:id",
    name: "CompanyView",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "CompanyView" */ "@/views/Company/View.vue"),
  },
  {
    path: "/usuario",
    name: "User",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "UserList" */ "@/views/User/List.vue"),
  },
  {
    path: "/usuario/novo",
    name: "UserAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "UserForm" */ "@/views/User/Form.vue"),
  },
  {
    path: "/usuario/:id",
    name: "UserEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "UserForm" */ "@/views/User/Form.vue"),
  },
  {
    path: "/usuario/:id/empresas",
    name: "UserCompanies",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "UserCompanies" */ "@/views/User/Companies.vue"
      ),
  },
  {
    path: "/produto",
    name: "Product",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "ProductList" */ "@/views/Product/List.vue"),
  },
  {
    path: "/produto/novo",
    name: "ProductAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "ProductForm" */ "@/views/Product/Form.vue"),
  },
  {
    path: "/produto/:id",
    name: "ProductEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "ProductForm" */ "@/views/Product/Form.vue"),
  },
  {
    path: "/importar-produto",
    name: "ProductImport",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProductImport" */ "@/views/Product/Import.vue"
      ),
  },
  {
    path: "/transportadora",
    name: "Shipping",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "GridList" */ "@/views/ShippingCompany/List.vue"
      ),
  },
  {
    path: "/transportadora/novo",
    name: "ShippingAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ShippingForm" */ "@/views/ShippingCompany/Form.vue"
      ),
  },
  {
    path: "/transportadora/:id",
    name: "ShippingEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ShippingForm" */ "@/views/ShippingCompany/Form.vue"
      ),
  },
  {
    path: "/grade-produto",
    exact: true,
    name: "Grid",
    component: () =>
      import(/* webpackChunkName: "GridList" */ "@/views/Grid/List.vue"),
  },
  {
    path: "/grade-produto/novo",
    name: "GridAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "GridForm" */ "@/views/Grid/Form.vue"),
  },
  {
    path: "/grade-produto/:id",
    name: "GridEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "GridForm" */ "@/views/Grid/Form.vue"),
  },
  {
    path: "/fornecedor-condicao",
    name: "PaymentProvider",
    exact: true,
    component: Development,
  },
  {
    path: "/pedido",
    name: "gridOrder",
    exact: true,
    component: Development,
  },
  {
    path: "/consulta-pedido",
    name: "searchOrder",
    exact: true,
    component: Development,
  },
  {
    path: "/expansao-pedido",
    name: "expansionOrder",
    exact: true,
    component: Development,
  },
  {
    path: "/reabrir-pedido",
    name: "reopenOrder",
    exact: true,
    component: Development,
  },
  {
    path: "/tecnologia",
    exact: true,
    name: "ProductTechnology",
    component: () =>
      import(
        /* webpackChunkName: "ProductTechnologyList" */ "@/views/ProductTechnology/List.vue"
      ),
  },
  {
    path: "/tecnologia/novo",
    name: "ProductTechnologyAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProductTechnologyAdd" */ "@/views/ProductTechnology/Form.vue"
      ),
  },
  {
    path: "/tecnologia/:id",
    name: "ProductTechnologyEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProductTechnologyEdit" */ "@/views/ProductTechnology/Form.vue"
      ),
  },
  {
    path: "/cor",
    exact: true,
    name: "Color",
    component: () =>
      import(/* webpackChunkName: "ColorList" */ "@/views/Color/List.vue"),
  },
  {
    path: "/cor/novo",
    name: "ColorAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "ColorAdd" */ "@/views/Color/Form.vue"),
  },
  {
    path: "/cor/:id",
    name: "ColorEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "ColorEdit" */ "@/views/Color/Form.vue"),
  },
  {
    path: "/material",
    exact: true,
    name: "Material",
    component: () =>
      import(
        /* webpackChunkName: "MaterialList" */ "@/views/Material/List.vue"
      ),
  },
  {
    path: "/material/novo",
    name: "MaterialAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "MaterialAdd" */ "@/views/Material/Form.vue"),
  },
  {
    path: "/material/:id",
    name: "MaterialEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "MaterialEdit" */ "@/views/Material/Form.vue"
      ),
  },
  {
    path: "/unidade-medida",
    exact: true,
    name: "Unit",
    component: () =>
      import(/* webpackChunkName: "UnitList" */ "@/views/Unit/List.vue"),
  },
  {
    path: "/unidade-medida/novo",
    name: "UnitAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "UnitAdd" */ "@/views/Unit/Form.vue"),
  },
  {
    path: "/unidade-medida/:id",
    name: "UnitEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "UnitEdit" */ "@/views/Unit/Form.vue"),
  },
  {
    path: "/modalidade-pagamento",
    exact: true,
    name: "PaymentMethod",
    component: () =>
      import(
        /* webpackChunkName: "PaymentMethodList" */ "@/views/PaymentMethod/List.vue"
      ),
  },
  {
    path: "/modalidade-pagamento/novo",
    name: "PaymentMethodAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "PaymentMethodForm" */ "@/views/PaymentMethod/Form.vue"
      ),
  },
  {
    path: "/modalidade-pagamento/:id",
    name: "PaymentMethodEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "PaymentMethodForm" */ "@/views/PaymentMethod/Form.vue"
      ),
  },
  {
    path: "/condicao-pagamento",
    exact: true,
    name: "PaymentCondition",
    component: () =>
      import(
        /* webpackChunkName: "PaymentConditionList" */ "@/views/PaymentCondition/List.vue"
      ),
  },
  {
    path: "/condicao-pagamento/novo",
    name: "PaymentConditionAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "PaymentConditionForm" */ "@/views/PaymentCondition/Form.vue"
      ),
  },
  {
    path: "/condicao-pagamento/:id",
    name: "PaymentConditionEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "PaymentConditionForm" */ "@/views/PaymentCondition/Form.vue"
      ),
  },
  {
    path: "/ncm",
    exact: true,
    name: "Ncm",
    component: () =>
      import(/* webpackChunkName: "NcmList" */ "@/views/Ncm/List.vue"),
  },
  {
    path: "/ncm/novo",
    name: "NcmAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "NcmForm" */ "@/views/Ncm/Form.vue"),
  },
  {
    path: "/ncm/:id",
    name: "NcmEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "NcmForm" */ "@/views/Ncm/Form.vue"),
  },

  {
    path: "/cest",
    exact: true,
    name: "Cest",
    component: () =>
      import(/* webpackChunkName: "CestList" */ "@/views/Cest/List.vue"),
  },
  {
    path: "/cest/novo",
    name: "CestAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "CestForm" */ "@/views/Cest/Form.vue"),
  },
  {
    path: "/cest/:id",
    name: "CestEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "CestForm" */ "@/views/Cest/Form.vue"),
  },
  // SOLADOS
  {
    path: "/solado",
    exact: true,
    name: "Sole",
    component: () =>
      import(/* webpackChunkName: "SoleList" */ "@/views/Sole/List.vue"),
  },
  {
    path: "/solado/novo",
    name: "SoleAdd",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "SoleForm" */ "@/views/Sole/Form.vue"),
  },
  {
    path: "/solado/:id",
    name: "SoleEdit",
    exact: true,
    component: () =>
      import(/* webpackChunkName: "SoleForm" */ "@/views/Sole/Form.vue"),
  },
  {
    path: "/tipo-produto",
    exact: true,
    name: "ProductType",
    component: () =>
      import(
        /* webpackChunkName: "ProductTypeList" */ "@/views/ProductType/List.vue"
      ),
  },
  {
    path: "/tipo-produto/novo",
    name: "ProductTypeAdd",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProductTypeForm" */ "@/views/ProductType/Form.vue"
      ),
  },
  {
    path: "/tipo-produto/:id",
    name: "ProductTypeEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProductTypeForm" */ "@/views/ProductType/Form.vue"
      ),
  },
  {
    path: "/email/hello",
    name: "EmailUserHello",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "EmailUserHello" */ "@/views/Email/UserHello.vue"
      ),
  },
  ...routerMaintenance,
  ...routerRoyalties,
  ...routerInvoices,
  ...routerReports,
  ...routerPhotos,
  ...routerProviders,
  ...routerExpress,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // base: process.env.BASE_URL + "/sergios/",
  routes,
});

// router.beforeEach((to, from, next) => {
//   console.log(to.query.ts);
//   if (!to.query.ts) {
//     console.log("entrou pq?");
//     console.log(to.query);
//     console.log(to.path);
//     to.query.ts = new Date().getTime();
//     next({ path: to.path, query: to.query });
//   } else {
//     console.log(to.path);
//     next();
//   }
// });
// router.afterEach((to, from, failure) => {
//   if (failure) {
//     console.log(failure);
//   }
// });

export default router;
